import axios from '../service/jfetch'
const $env = process.env.VUE_APP_PREFIX
let auth = {
    init(vue){
        vue.prototype.$checkLogin = this.checkLogin
        vue.prototype.$registLogin = this.registLogin
        vue.prototype.$logout = this.logout
    },
    
    registerAuth(vue,router){
        router.beforeEach((to, from, next) => {
          localStorage.setItem($env+"moduleName",to.meta.title);
          localStorage.setItem($env+"curl",to.path);
          if(to.meta.title === "积惠多便利店" || to.meta.title === "分类" || to.meta.title === "购物车" || to.meta.title === "确认订单" || to.meta.title === "订单详情"){
            localStorage.setItem(process.env.VUE_APP_PREFIX+"enterDetail",to.path)
          }
          next()
        })
    },

    checkLogin(){
        if(localStorage.getItem($env+"authToken")){
            window.AUTH_TOKEN = localStorage.getItem($env+"authToken");
            return true
        }
    },

    registLogin(memberId,data,callback){
        localStorage.setItem($env+"authToken",data.accessToken)
        localStorage.setItem($env+"memberId",memberId)
        localStorage.setItem($env+"refreshToken",data.refreshToken)
        let accessTokenExpiration = (new Date()).getTime() + 20 * 60 * 1000;
        localStorage.setItem($env+"expriredAt",data.accessTokenExpiration || accessTokenExpiration)
        // utils.setExpiredAt(data.expiresIn)
        axios.defaults.headers.common['Authorization'] = "Bearer " + data.accessToken;
        callback && callback()
    },

    logout(callback){
        // localStorage.removeItem($env+"memberId");
        localStorage.removeItem($env+"authToken");
        localStorage.removeItem($env+"refreshToken");
        callback && callback()
        // this.$router.push({path:"/login"})
    }
}

auth.install = function(Vue,router){
    this.init(Vue)
    this.registerAuth(Vue,router)
}

export default auth